import { CategoryFilter } from './category-filter';
import { BrandFilter } from './brand-filter';
import { PriceFilter } from './price-filter';
// import { useAttributes } from '@framework/attributes';
// import { AttributesFilter } from '@components/shop/attributes-filter';

import { SortFilters } from './sort-filters';
import { useRouter } from 'next/router';
// import { FilterQueryTags } from './filter-query-tags';

interface ShopFiltersProps {
  exclude?: string[];
}

export const ShopFilters: React.FC<ShopFiltersProps> = ({ exclude = [] }) => {
  const {
    query: { slug },
  } = useRouter();

  // const { data } = useAttributes();

  return (
    <div className="w-full h-full flex flex-col gap-4 md:gap-8 3xl:gap-12 overflow-y-scroll overflow-x-hidden">
      {/* <FilterQueryTags /> */}
      <SortFilters />
      {!exclude.includes('category') && <CategoryFilter />}
      {!slug && !exclude.includes('brand') && <BrandFilter />}
      <PriceFilter />

      {/* {data && <AttributesFilter attributes={data} />} */}
    </div>
  );
};
